import { Rule } from 'antd/es/form'
import { useTranslation } from 'react-i18next'

const useRailcarRules = () => {
  const { t } = useTranslation()

  const railCarRules: { [key: string]: Rule[] } = {
    railCarId: [
      {
        required: true,
        message: t('please_input_railcar_ID'),
      },
      {
        pattern: /^[0-9-]+$/,
        message: t('only_numbers_and_hyphens_allowed'),
      },
      {
        min: 3,
        message: t('min_3_characters'),
      },
      {
        max: 30,
        message: t('max_30_characters'),
      },
    ],
  }

  return railCarRules
}

export { useRailcarRules }
